// Generated by Melange

import * as VerigramJs from "./verigram.js";

function launchScanScript(prim0, prim1, prim2, prim3, prim4) {
  VerigramJs.launchScanScript(prim0, prim1, prim2, prim3, prim4);
}

function launchLivenessScript(prim0, prim1, prim2, prim3, prim4) {
  VerigramJs.launchLivenessScript(prim0, prim1, prim2, prim3, prim4);
}

export {
  launchScanScript ,
  launchLivenessScript ,
}
/* ./verigram.js Not a pure module */
